import { MantineThemeOverride } from '@mantine/core';

export type NativeSelectTheme = NonNullable<MantineThemeOverride['components']>['NativeSelect'];

export const NativeSelect: NativeSelectTheme = {
  // todo: define
};
